import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import ValidationElement from '../ValidationElement';
import Text from '../Text';


const digitsDashOnly = (value = '') => {
  let result = value;
  if (!(/^[\d-]+$/.exec(value))) {
    result = value?.replace(/\D/g, '');
  }
  return result;
};

export default class ZipCode extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.handleError = this.handleError.bind(this);

    this.zipcode = React.createRef();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.value, this.props.value)) {
      this.setState({
        value: nextProps.value,
      });
    }
  }

  handleError(value, arr) {
    // When both of the following errors occur at same time, suppress the state error
    // The ZIP Code should be either 5 or 9 digits.
    // The ZIP Code must be from the state in the address.
    let isPatternValid = true;
    let arr2 = cloneDeep(arr);
    arr2.forEach((err) => {
      if (err.code.indexOf('pattern') !== -1) {
        isPatternValid = err.valid;
      }
    });

    arr2 = arr2.map((err) => ({
      code: `zipcode.${err.code}`,
      valid: err.code.indexOf('status') !== -1 && !isPatternValid ? true : err.valid,
      uid: err.uid,
    }));

    return this.props.onError(value, arr2);
  }

  render() {
    let changeablePlaceholder = this.props.placeholder;
    if (this.props.showDisabledText && this.props.value && this.props.disabled) {
      changeablePlaceholder = this.props.value;
    }

    const regex = new RegExp('[^0-9-]', 'g');

    return (
      <Text
        attribute={this.props.attribute}
        name={this.props.name}
        ref={this.zipcode}
        label={this.props.label}
        placeholder={changeablePlaceholder}
        className={this.props.className}
        pattern="^\d{5}(?:[-\s]{0,1}\d{4})?$"
        prefilter={digitsDashOnly}
        inputFilter={regex}
        status={this.props.status}
        required={this.props.required}
        disabled={this.props.disabled}
        value={this.state.value}
        onUpdate={this.props.onUpdate}
        onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
        tabBack={this.props.tabBack}
        tabNext={this.props.tabNext}
      />
    );
  }
}

ZipCode.defaultProps = {
  value: '',
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
  required: false,
  status: false,
  showDisabledText: false,
};

ZipCode.errors = [];
